<script setup>
const emit = defineEmits(["click"]);
</script>
<template>
    <a class="view-all-times" data-test="view-all-times" @click="emit('click')">View all times</a>
</template>
<style scoped>
a.view-all-times {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1.3rem;
    text-decoration-line: underline;
    color: #260045;
    cursor: pointer;
}
</style>
